<div class="a3l-ui-progress-bar__track" [style.width.%]="value"></div>
<div class="a3l-ui-progress-bar__thumb" [style.left.%]="value" *ngIf="mode == 'determinate'"></div>
